import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { apiCall } from "../../../../utils/axiosService";
import { API_URL } from "../../../../utils/apiRoutes";
import { apiResponse } from "../../../../utils/apiResponse";
import Loader from "../../../Loader/Loader";
import { commonService } from "../../../../utils/commonService";

const FlagPopup = ({ showModal, closeModal, data }) => {
  const [loading, setLoading] = useState(false);
  const [newData, setNewData] = useState();
  const getFlagData = async () => {
    setLoading(true);
    let threadResponse = await apiCall(
      {
        method: "POST",
        url:
          API_URL.BASE_API_URL.SnapShot +
          API_URL.REVENUE_GLANCE.FLAG_AI_SUMMARY,
        body: {
          asofdate: data?.asofdate,
          dates: data?.dates,
          propertycode: data?.propertycode,
        },
      },
      false
    );
    let response = apiResponse(false, threadResponse);
    if (response?.isValidate) {
      setNewData(response?.data?.data);
    }
    setLoading(false);
  };

  useEffect(() => {
    getFlagData();
  }, []);
  return (
    <Modal
      className="DeviceDetailModalMain"
      centered
      size="lg"
      show={showModal}
      onHide={closeModal}
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">Summary</Modal.Title>
         <button
                    id={commonService.generateGlobalClickTrackerID(`copilot-popup`, `ask-rm-copilot-close-btn`, `${data?.dates}`)}
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={closeModal}
                  ></button>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <Loader />
        ) : (
          <div
            className="ms-4"
            dangerouslySetInnerHTML={{ __html: newData?.message }}
          />
        )}
      </Modal.Body>
    </Modal>
  );
};

export default FlagPopup;
